/* TigerFormel 2026 · Vanilla JS */
(function () {
  'use strict';
  var d = document;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  /* Menü */
  var burger = $('[data-menu]'), nav = $('#nav');
  if (burger && nav) {
    var setMenu = function (open) {
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      $('[data-ico-open]', burger).hidden = open;
      $('[data-ico-close]', burger).hidden = !open;
    };
    burger.addEventListener('click', function () { setMenu(!nav.classList.contains('is-open')); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) { setMenu(false); burger.focus(); } });
  }

  /* Kaufbox: gewähltes Paket in Summe und Sticky-Leiste spiegeln */
  var fmt = function (c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + '\u00a0€'; };
  var aboUpd = function () {};
  $$('.bx').forEach(function (box) {
    var pf = $('[data-plans]', box), map = {};
    try { map = pf ? JSON.parse(pf.dataset.plans) : {}; } catch (e) { map = {}; }
    aboUpd = function (r) {
      if (!pf) return;
      var n1 = !r || Number(r.dataset.n || 1) === 1;
      pf.hidden = !n1;
      if (!n1) { var one = $('input[name="selling_plan"][value=""]', box); if (one) one.checked = true; }
      var pl = $('input[name="selling_plan"]:checked', box), id = pl ? pl.value : '';
      box.classList.toggle('is-abo', !!id);
      $$('[data-plan-d]', box).forEach(function (p) { p.hidden = p.dataset.planD !== id; });
      var sum = $('[data-bx-price]', box), key = r ? r.value + ':' + id : '';
      var al = $('[data-abo-line]', box), sm = $('[data-abo-small]', box), ab = r && map[r.value + ':' + (pl && pl.value ? pl.value : $('input[name="selling_plan"]:not([value=""])', box).value)];
      if (sm && ab) sm.textContent = fmt(ab) + ' im Monat';
      if (al && ab && r) { var base = Math.round(parseFloat(r.dataset.price.replace(/[^0-9,]/g, '').replace(',', '.')) * 100), pct = base ? Math.round((1 - ab / base) * 100) : 0; al.textContent = pct > 0 ? 'Abo: ' + fmt(ab) + ' im Monat statt ' + r.dataset.price + ', ' + pct + ' % sparen, jederzeit kündbar.' : 'Abo: ' + fmt(ab) + ' im Monat, jederzeit kündbar.'; }
      if (id && sum && map[key]) { sum.textContent = fmt(map[key]); var dy = $('[data-bx-day]', box), n = Number(r.dataset.n || 1); if (dy) dy.textContent = fmt(Math.round(map[key] / n / 30)); }
    };
    if (pf) pf.addEventListener('change', function () { var r = $('input[name="id"]:checked', box); if (r) { var sum = $('[data-bx-price]', box); if (sum) sum.textContent = r.dataset.price; var dy = $('[data-bx-day]', box); if (dy) dy.textContent = r.dataset.day; } aboUpd(r); });
    var sum = $('[data-bx-price]', box), nm = $('[data-bx-name]', box);
    var sp = $('[data-sticky-price]'), sn = $('[data-sticky-name]');
    function upd() {
      var r = $('input[name="id"]:checked', box);
      if (!r) return;
      if (sum) sum.textContent = r.dataset.price;
      if (nm) nm.textContent = r.dataset.name;
      var dy = $('[data-bx-day]', box); if (dy) dy.textContent = r.dataset.day;
      aboUpd(r);
      if (sp && box.closest('[data-buybox]')) { sp.textContent = r.dataset.price; sn.textContent = r.dataset.name; }
    }
    box.addEventListener('change', upd);
    upd();
  });

  /* Sticky-Kaufleiste (Handy), sobald die Kaufbox aus dem Bild ist */
  var sticky = $('[data-sticky]'), bb = $('[data-buybox]');
  if (sticky && bb && 'IntersectionObserver' in window) {
    var btn = $('[data-sticky-btn]', sticky);
    new IntersectionObserver(function (en) {
      var out = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', out); document.body.classList.toggle('has-sticky', out);
      sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
      if (btn) btn.tabIndex = out ? 0 : -1;
    }, { threshold: 0 }).observe(bb);
  }


  /* Sticky-Kaufleiste auf der Startseite: nach dem Hero, weg sobald die Paketwahl zu sehen ist */
  var shm = $('[data-sticky-home]'), shHero = $('.hx'), shBuy = $('#paket');
  if (shm && shHero && shBuy && 'IntersectionObserver' in window) {
    var shBtn = $('[data-sticky-home-btn]', shm), sh = { h: true, b: false };
    var shUpd = function () { var on = !sh.h && !sh.b; shm.classList.toggle('is-on', on); document.body.classList.toggle('has-sticky', on); shm.setAttribute('aria-hidden', on ? 'false' : 'true'); if (shBtn) shBtn.tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (e) { sh.h = e[0].isIntersecting; shUpd(); }).observe(shHero);
    new IntersectionObserver(function (e) { sh.b = e[0].isIntersecting; shUpd(); }).observe(shBuy);
  }

  /* Reels: Pfeile am Desktop */
  $$('[data-reels]').forEach(function (b) {
    b.addEventListener('click', function () {
      var s = $('[data-reels-strip]');
      if (s) s.scrollBy({ left: Number(b.dataset.reels) * 480, behavior: 'smooth' });
    });
  });


  /* Video-Popup: Instagram-Reel, YouTube oder MP4. Fremdinhalt erst nach Klick (oder bei vorhandener Marketing-Einwilligung) */
  var vm = $('#vm');
  if (vm) {
    var vBody = $('[data-vm-body]', vm), vAsk = $('[data-vm-ask]', vm), vT = $('#vm-t', vm), vExt = $('[data-vm-ext]', vm), vHost = $('[data-vm-host]', vm);
    var vLast = null, vCur = null;
    function parse(u) {
      var m;
      if ((m = /instagram\.com\/(?:reel|reels|p|tv)\/([\w-]+)/.exec(u))) return { k: 'ig', src: 'https://www.instagram.com/reel/' + m[1] + '/embed', host: 'Instagram', ext: u };
      if ((m = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/))([\w-]{6,})/.exec(u))) return { k: 'yt', src: 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0', host: 'YouTube', ext: 'https://www.youtube.com/watch?v=' + m[1] };
      if (/\.(mp4|webm)(\?|$)/i.test(u)) return { k: 'mp4', src: u, host: '', ext: u };
      return null;
    }
    function marketingOk() {
      try { var c = JSON.parse(localStorage.getItem('tf_consent')); if (c && c.marketing) return true; } catch (e) {}
      try { var a = window.Shopify && window.Shopify.customerPrivacy; if (a && a.currentVisitorConsent && a.currentVisitorConsent().marketing === 'yes') return true; } catch (e) {}
      return false;
    }
    function load() {
      var v = vCur; if (!v) return;
      vAsk.hidden = true; vBody.innerHTML = '';
      var el;
      if (v.k === 'mp4') { el = d.createElement('video'); el.controls = true; el.autoplay = true; el.playsInline = true; el.src = v.src; }
      else { el = d.createElement('iframe'); el.src = v.src; el.title = vT.textContent; el.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; el.allowFullscreen = true; }
      vBody.appendChild(el);
    }
    function openVm(a) {
      var v = parse(a.getAttribute('data-vm') || ''); if (!v) return false;
      vCur = v; vLast = a;
      vT.textContent = a.getAttribute('data-vm-title') || 'Video';
      vm.classList.toggle('vm--wide', v.k !== 'ig');
      vBody.innerHTML = ''; vExt.href = v.ext; vHost.textContent = v.host;
      vm.hidden = false; d.documentElement.classList.add('vm-open');
      if (v.k === 'mp4' || marketingOk()) load(); else vAsk.hidden = false;
      $('[data-vm-close]', vm).focus();
      return true;
    }
    function closeVm() {
      vm.hidden = true; vBody.innerHTML = ''; vCur = null; d.documentElement.classList.remove('vm-open');
      if (vLast) { vLast.focus(); vLast = null; }
    }
    d.addEventListener('click', function (e) {
      var a = e.target.closest('[data-vm]');
      if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey && openVm(a)) { e.preventDefault(); return; }
      if (e.target.closest('[data-vm-close]') || e.target === vm) closeVm();
      else if (e.target.closest('[data-vm-load]')) load();
    });
    d.addEventListener('keydown', function (e) {
      if (vm.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closeVm(); return; }
      if (e.key === 'Tab') {
        var f = $$('button,a[href],iframe,video', vm).filter(function (x) { return !x.closest('[hidden]') && x.offsetParent !== null; });
        if (!f.length) return;
        var i = f.indexOf(d.activeElement), n = e.shiftKey ? i - 1 : i + 1;
        if (i === -1 || n < 0 || n >= f.length) { e.preventDefault(); f[n < 0 ? f.length - 1 : 0].focus(); }
      }
    });
  }

  /* Galerie und Lightbox */
  $$('[data-gl]').forEach(function (gl) {
    var track = $('[data-gl-track]', gl), slides = $$('.gl__slide', gl), ths = $$('[data-gl-th]', gl), dots = $$('.gl__dots li', gl);
    function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
    function mark(i) {
      ths.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
    }
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { mark(cur()); }); });
    ths.forEach(function (t) { t.addEventListener('click', function () { track.scrollTo({ left: Number(t.dataset.glTh) * track.clientWidth, behavior: 'smooth' }); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' }); } });
    var lb = $('[data-lb]'), img = $('[data-lb-img]', lb), stage = $('[data-lb-stage]', lb), cnt = $('[data-lb-count]', lb), items = $$('.gl__open', gl), li = 0, last = null;
    function show(i) {
      li = (i + items.length) % items.length; var it = items[li];
      lb.classList.remove('lb--zoom'); img.src = it.dataset.full; img.alt = it.dataset.alt || '';
      cnt.textContent = 'Bild ' + (li + 1) + ' von ' + items.length; stage.scrollTo(0, 0);
    }
    function open(i, from) { last = from; show(i); lb.hidden = false; d.documentElement.classList.add('vm-open'); $('[data-lb-close]', lb).focus(); }
    function close() { lb.hidden = true; d.documentElement.classList.remove('vm-open'); track.scrollTo({ left: li * track.clientWidth }); mark(li); if (last) last.focus(); }
    items.forEach(function (b, k) { b.addEventListener('click', function () { open(k, b); }); });
    function zoom(on, e) {
      var z = on === undefined ? !lb.classList.contains('lb--zoom') : on; lb.classList.toggle('lb--zoom', z);
      if (z && e) { var r = stage.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height; requestAnimationFrame(function () { stage.scrollLeft = fx * (stage.scrollWidth - stage.clientWidth); stage.scrollTop = fy * (stage.scrollHeight - stage.clientHeight); }); }
    }
    stage.addEventListener('click', function (e) { zoom(undefined, e); });
    stage.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' && lb.classList.contains('lb--zoom')) { var r = stage.getBoundingClientRect(); stage.scrollLeft = (e.clientX - r.left) / r.width * (stage.scrollWidth - stage.clientWidth); stage.scrollTop = (e.clientY - r.top) / r.height * (stage.scrollHeight - stage.clientHeight); } });
    $('[data-lb-zoom]', lb).addEventListener('click', function () { zoom(); });
    $('[data-lb-prev]', lb).addEventListener('click', function () { show(li - 1); });
    $('[data-lb-next]', lb).addEventListener('click', function () { show(li + 1); });
    $('[data-lb-close]', lb).addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    d.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); } else if (e.key === 'ArrowRight') show(li + 1); else if (e.key === 'ArrowLeft') show(li - 1);
      else if (e.key === 'Tab') { var f = $$('button', lb), i = f.indexOf(d.activeElement), n = e.shiftKey ? i - 1 : i + 1; if (i === -1 || n < 0 || n >= f.length) { e.preventDefault(); f[n < 0 ? f.length - 1 : 0].focus(); } }
    });
  });

  /* Testosteron-Check: Parameter, Einwilligung und Einbett-Modus an den eingebetteten Check geben, Höhe von dort übernehmen */
  function consentAll() {
    try { var c = JSON.parse(localStorage.getItem('tf_consent')); if (c && c.marketing) return true; } catch (e) {}
    try { var a = window.Shopify && window.Shopify.customerPrivacy; if (a && a.currentVisitorConsent && a.currentVisitorConsent().marketing === 'yes') return true; } catch (e) {}
    return false;
  }
  $$('[data-check-frame]').forEach(function (f) {
    var ok = 'https://maennermehrwert.de';
    try {
      var u = new URL(f.dataset.src, location.href), q = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'cam', 'fbclid', 'src', 'ds24tr'].forEach(function (k) { if (q.get(k)) u.searchParams.set(k, q.get(k)); });
      u.searchParams.set('embed', '1'); u.searchParams.set('consent', consentAll() ? 'all' : 'necessary');
      ok = u.origin; f.src = u.toString();
    } catch (e) { f.src = f.dataset.src; }
    window.addEventListener('message', function (e) {
      if (e.origin !== ok || e.source !== f.contentWindow || !e.data || e.data.type !== 'tcheck-height') return;
      var h = Number(e.data.h); if (h > 200 && h < 20000) f.style.height = Math.ceil(h) + 'px';
      if (e.data.scroll) { var r = f.getBoundingClientRect(); if (r.top < 0 || r.top > 120) window.scrollTo({ top: window.pageYOffset + r.top - 70, behavior: 'smooth' }); }
    });
  });

  /* YouTube: erst nach Klick laden */
  $$('[data-yt]').forEach(function (v) {
    var b = $('button', v);
    if (!b) return;
    b.addEventListener('click', function () {
      var f = d.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(v.dataset.yt) + '?autoplay=1&rel=0';
      f.title = 'YouTube-Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      v.innerHTML = '';
      v.appendChild(f);
    });
  });

  /* Cookie-Banner mit Shopify Customer Privacy API */
  var ck = $('#ck');
  if (ck) {
    var KEY = 'tf_consent';
    var set = $('#ck-set'), more = $('[data-ck="more"]');
    var opts = {};
    $$('[data-ck-opt]', ck).forEach(function (i) { opts[i.dataset.ckOpt] = i; });
    var api = function () { return window.Shopify && window.Shopify.customerPrivacy; };
    function cm(c) { if (typeof window.gtag !== 'function') return; var m = c.marketing ? 'granted' : 'denied'; window.gtag('consent', 'update', { ad_storage: m, ad_user_data: m, ad_personalization: m, analytics_storage: c.analytics ? 'granted' : 'denied' }); }
    function show(v) { ck.hidden = !v; }
    function apply(c) {
      try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
      var a = api();
      if (a && a.setTrackingConsent) {
        a.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, function () {});
      }
      cm(c);
      show(false);
    }
    function stored() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
    function init() {
      var a = api(), known = false;
      if (a && a.currentVisitorConsent) {
        var cv = a.currentVisitorConsent();
        known = cv && (cv.marketing === 'yes' || cv.marketing === 'no') && (cv.analytics === 'yes' || cv.analytics === 'no');
        if (known) { cm({ analytics: cv.analytics === 'yes', marketing: cv.marketing === 'yes' }); opts.analytics.checked = cv.analytics === 'yes'; opts.marketing.checked = cv.marketing === 'yes'; opts.preferences.checked = cv.preferences === 'yes'; }
      } else { known = !!stored(); }
      show(!known);
    }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { init(); });
    } else { init(); }
    ck.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ck]'); if (!t) return;
      var k = t.dataset.ck;
      if (k === 'accept') apply({ analytics: true, marketing: true, preferences: true });
      else if (k === 'reject') apply({ analytics: false, marketing: false, preferences: false });
      else if (k === 'save') apply({ analytics: opts.analytics.checked, marketing: opts.marketing.checked, preferences: opts.preferences.checked });
      else if (k === 'more') { var o = set.hidden; set.hidden = !o; more.setAttribute('aria-expanded', o ? 'true' : 'false'); }
    });
    d.addEventListener('click', function (e) {
      var o = e.target.closest('[data-ck-open]');
      if (o) { e.preventDefault(); show(true); set.hidden = false; more.setAttribute('aria-expanded', 'true'); }
    });
  }

  /* Anker nach dem Laden zuverlässig ansteuern (Bilder und Schriften verschieben sonst das Ziel) */
  function toHash() {
    var h = location.hash; if (h.length < 2) return;
    var el; try { el = d.getElementById(decodeURIComponent(h.slice(1))); } catch (e) {}
    if (!el) return;
    if (Math.abs(el.getBoundingClientRect().top - 84) > 24) el.scrollIntoView({ block: 'start' });
  }
  if (location.hash.length > 1) {
    var run = function () { toHash(); setTimeout(toHash, 400); setTimeout(toHash, 1200); };
    if (d.readyState === 'complete') run(); else window.addEventListener('load', run);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { setTimeout(toHash, 60); });
  }
  window.addEventListener('hashchange', toHash);
})();

/* Direkt zur Kasse: Warenkorb leeren, Paket (ggf. mit Abo) hinzufügen, Herkunft als Warenkorb-Attribute, dann /checkout */
(function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'cam', 'ds24tr', 'src', 'fbclid', 'gclid', 'gbraid', 'wbraid'];
  function attrs() {
    var st = {}, q = new URLSearchParams(location.search);
    try { st = JSON.parse(sessionStorage.getItem('tf_attr') || '{}') || {}; } catch (e) {}
    KEYS.forEach(function (k) { if (q.get(k)) st[k] = q.get(k); });
    try { sessionStorage.setItem('tf_attr', JSON.stringify(st)); } catch (e) {}
    return st;
  }
  attrs();
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function post(u, b) { return fetch(u, { method: 'POST', headers: J, body: JSON.stringify(b || {}), credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(u + ' ' + r.status); return r; }); }
  function go(items, code, upg) {
    var a = attrs(); if (upg) a.tf_upgrade = upg;
    var fbp = (document.cookie.match(/(?:^|; )_fbp=([^;]+)/) || [])[1]; if (fbp) a.fbp = fbp;
    return post('/cart/clear.js').then(function () { return post('/cart/add.js', { items: items }); }).then(function () {
      return Object.keys(a).length ? post('/cart/update.js', { attributes: a }) : null;
    }).then(function () { location.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); });
  }
  function qs(extra) { var a = attrs(), p = []; Object.keys(extra || {}).forEach(function (k) { p.push(k + '=' + encodeURIComponent(extra[k])); }); KEYS.forEach(function (k) { if (a[k]) p.push(k + '=' + encodeURIComponent(a[k])); }); return p.length ? '?' + p.join('&') : ''; }
  var busy = false;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action="/cart/add"]')) return;
    var fd = new FormData(f), id = fd.get('id'); if (!id || busy) { if (busy) e.preventDefault(); return; }
    if (!document.querySelector('.pp')) { e.preventDefault(); location.href = ((f.querySelector('[data-product-url]') || {}).value || location.pathname) + qs({ variant: id }); return; }
    e.preventDefault(); busy = true;
    var it = { id: Number(id), quantity: Number(fd.get('quantity') || 1) }, sp = fd.get('selling_plan'); if (sp) it.selling_plan = Number(sp);
    if (!sp && upgrade(f, id, function (nid, info) { if (nid) it.id = Number(nid); send(it, info); })) return;
    send(it);
  }, true);
  /* Upgrade-Angebot vor der Kasse: ein Klick auf das nächste Paket (1 auf 3, 3 auf 6, 6 auf 12), einmal pro Sitzung */
  var NEXT = { 1: 3, 3: 6, 6: 12 };
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €'; }
  function cents(t) { return Math.round(parseFloat(String(t).replace(/[^0-9,.]/g, '').replace('.', '').replace(',', '.')) * 100); }
  function upgrade(f, id, done) {
    if (!f.querySelector('[data-upgrade-on]')) return false;
    try { if (sessionStorage.getItem('tf_upg')) return false; } catch (e) {}
    var r = f.querySelector('input[name="id"][value="' + id + '"]'); if (!r) return false;
    var n = Number(r.dataset.n || 1), m = NEXT[n]; if (!m) return false;
    var t = f.querySelector('input[name="id"][data-n="' + m + '"]:not([disabled])'); if (!t) return false;
    var p1 = cents(r.dataset.price), p2 = cents(t.dataset.price), d1 = Math.round(p1 / n), d2 = Math.round(p2 / m);
    if (!(p2 > p1) || !(d2 < d1)) return false;
    try { sessionStorage.setItem('tf_upg', '1'); } catch (e) {}
    var dl = document.createElement('dialog'); dl.className = 'upg'; dl.setAttribute('aria-labelledby', 'upg-h');
    dl.innerHTML = '<p class="upg__k">Kleiner Tipp vor der Kasse</p>' +
      '<h2 id="upg-h" class="upg__h">' + m + ' Dosen statt ' + n + (n === 1 ? ' Dose' : ' Dosen') + '?</h2>' +
      '<p class="upg__t">Mit ' + m + ' Dosen zahlst Du <b>' + eur(d2) + ' pro Dose</b> statt ' + eur(d1) + '. Für ' + eur(p2 - p1) + ' mehr hast Du Vorrat für ' + m + ' Monate.</p>' +
      '<button type="button" class="btn btn--block" data-upg="ja">Ja, ' + m + ' Dosen für ' + eur(p2) + '</button>' +
      '<button type="button" class="upg__nein" data-upg="nein">Nein danke, bei ' + n + (n === 1 ? ' Dose' : ' Dosen') + ' bleiben</button>' +
      '<p class="upg__f">Kostenloser Versand in DE · 30 Tage Geld zurück</p>';
    document.body.appendChild(dl);
    var fin = function (ja) { try { dl.close(); } catch (e) {} dl.remove(); done(ja ? t.value : null, (ja ? 'ja ' : 'nein ') + n + '>' + m); };
    dl.addEventListener('click', function (e) { var b = e.target.closest('[data-upg]'); if (b) fin(b.dataset.upg === 'ja'); });
    dl.addEventListener('cancel', function (e) { e.preventDefault(); fin(false); });
    if (dl.showModal) dl.showModal(); else return false;
    return true;
  }
  function send(it, info) {
    var btns = [].slice.call(document.querySelectorAll('[data-bx-submit],[data-sticky-btn]')), old = btns.map(function (b) { return b.textContent; });
    btns.forEach(function (b) { b.textContent = 'Einen Moment'; b.disabled = true; });
    go([it], null, info).catch(function () { busy = false; btns.forEach(function (b, i) { b.textContent = old[i]; b.disabled = false; }); location.href = '/cart/' + it.id + ':1'; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-direct-variant]'); if (!a || busy || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (!document.querySelector('.pp')) {
      e.preventDefault(); var base = new URL(a.href, location.href).pathname, tgt = base + qs({ variant: a.dataset.directVariant });
      location.href = a.dataset.discount ? '/discount/' + encodeURIComponent(a.dataset.discount) + '?redirect=' + encodeURIComponent(tgt) : tgt; return;
    }
    e.preventDefault(); busy = true;
    go([{ id: Number(a.dataset.directVariant), quantity: 1 }], a.dataset.discount).catch(function () { busy = false; location.href = a.href; });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; [].slice.call(document.querySelectorAll('[data-bx-submit],[data-sticky-btn]')).forEach(function (b) { b.disabled = false; b.textContent = 'Verfügbarkeit prüfen'; }); } });
})();

/* Etikett-Lightbox (natives dialog) */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lb]');
    if (b) { var d = document.getElementById(b.getAttribute('data-lb')); if (d && d.showModal) { e.preventDefault(); d.showModal(); } return; }
    var dlg = e.target; if (dlg && dlg.classList && dlg.classList.contains('lbx')) dlg.close();
    if (e.target.tagName === 'IMG' && e.target.closest && e.target.closest('.lbx')) e.target.closest('.lbx').close();
  });
})();

/* Newsletter-Anmeldung (nur aktiv, wenn im Theme eingeschaltet) */
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('[data-nl-form]')) return; e.preventDefault();
    var msg = f.querySelector('[data-nl-msg]'), email = f.elements.email.value.trim();
    if (email.indexOf('@') < 1) { msg.textContent = 'Bitte trage Deine E-Mail-Adresse ein.'; return; }
    if (!f.elements.consent.checked) { msg.textContent = 'Bitte bestätige die Einwilligung.'; return; }
    var attr = {}; try { attr = JSON.parse(sessionStorage.getItem('tf_attr') || '{}') || {}; } catch (x) {}
    var btn = f.querySelector('button'); btn.disabled = true; msg.textContent = 'Einen Moment …';
    fetch(f.getAttribute('data-api'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, website: f.elements.website.value, consent: true, tag: 'tf-shop-newsletter', page: location.pathname, utm: attr }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { msg.textContent = d.message || (d.ok ? 'Fast geschafft. Bitte bestätige Deine Anmeldung per Link in der E-Mail.' : 'Das hat leider nicht geklappt.'); if (d.ok) f.reset(); })
      .catch(function () { msg.textContent = 'Das hat leider nicht geklappt. Bitte versuche es später noch einmal.'; })
      .then(function () { btn.disabled = false; });
  });
})();

/* Links zur Produktseite tragen utm, cam, ds24tr weiter */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href*="/products/"]'); if (!a || a.hasAttribute('data-direct-variant')) return;
  try { var u = new URL(a.href, location.href); if (u.origin !== location.origin || /utm_source=/.test(u.search)) return; var s = JSON.parse(sessionStorage.getItem('tf_attr') || '{}'); Object.keys(s).forEach(function (k) { u.searchParams.set(k, s[k]); }); a.href = u.pathname + u.search + u.hash; } catch (x) {}
}, true);

/* 01.11.2026: Shopify-Cookie-Banner. Zustimmung an Google Consent Mode und tf_consent weitergeben */
document.addEventListener('visitorConsentCollected', function (e) {
  var d = e.detail || {}, c = { analytics: !!d.analyticsAllowed, marketing: !!d.marketingAllowed, preferences: !!d.preferencesAllowed };
  try { localStorage.setItem('tf_consent', JSON.stringify(c)); } catch (x) {}
  if (typeof window.gtag === 'function') { var m = c.marketing ? 'granted' : 'denied'; window.gtag('consent', 'update', { ad_storage: m, ad_user_data: m, ad_personalization: m, analytics_storage: c.analytics ? 'granted' : 'denied' }); }
});
